import { render } from "./serviceInfo.vue?vue&type=template&id=333e90e0&scoped=true&ts=true"
import script from "./serviceInfo.vue?vue&type=script&lang=ts"
export * from "./serviceInfo.vue?vue&type=script&lang=ts"

import "./serviceInfo.vue?vue&type=style&index=0&id=333e90e0&scoped=true&lang=scss"

import exportComponent from "E:\\bjft\\bjft-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333e90e0"]])

export default __exports__